import * as React from 'react';
import TimeSelect from '../../shared/TimeSelect';
import ContainersService from '../../shared/services/ContainersService';
import {ApiResponse} from '../../shared/CommonInterfaces';
import DropoffHelper from '../../dropoffs/shared/DropoffHelper';
import {Inbound} from '../shared/InboundInterfaces';

interface Props {
  inbound: Inbound;
  instructions: string;
  containersService: ContainersService;
  handleApiError: (errors: string[], response: ApiResponse<any>) => void;
  reloadContainer: () => void;
}

const ConfirmInbound: React.FC<Props> = (props) => {
  const {inbound, instructions, containersService, handleApiError, reloadContainer} = props;
  const [showValidation, setShowValidation] = React.useState<boolean>(false);
  const [inboundStartTimeState, setInboundStartTime] = React.useState<number>();
  const [inboundEndTimeState, setInboundEndTime] = React.useState<number>();
  const inboundStartTimeFormatted = Number.isInteger(inboundStartTimeState)
    ? DropoffHelper.msToHoursAndMinutes(inboundStartTimeState)
    : inbound.receivingWindow.startAt;

  const inboundEndTimeFormatted = Number.isInteger(inboundEndTimeState)
    ? DropoffHelper.msToHoursAndMinutes(inboundEndTimeState)
    : inbound.receivingWindow.endAt;

  const timeValidation = () => {
    return inboundStartTimeState <= inboundEndTimeState;
  };

  const startTimeChangeHandler = (event) => {
    setShowValidation(false);
    setInboundStartTime(DropoffHelper.hoursAndMinutesToMs(event.target.value));
  };

  const endTimeChangeHandler = (event) => {
    setShowValidation(false);
    setInboundEndTime(DropoffHelper.hoursAndMinutesToMs(event.target.value));
  };

  const confirmDelivery = async () => {
    if (!timeValidation()) {
      setShowValidation(true);
      return;
    }
    const response = await containersService.confirmDelivery({
      id: inbound.id,
      startTime: inboundStartTimeState,
      endTime: inboundEndTimeState,
      instructions
    });
    if (response && response.errors.length === 0) {
      reloadContainer();
      //remove any error displayed in the UI
      handleApiError([], undefined);
    } else {
      setShowValidation(false);
      handleApiError([`There was an error confirming delivery #${inbound.id}`], response);
    }
  };

  return (
    <div>
      <h2>Confirmation of Delivery</h2>
      <p>
        The Shipper has made a inbound request for an incoming container. Please confirm that your warehouse can
        accommodate this request.
      </p>
      {showValidation && (
        <div className="alert alert-danger">
          <span>Invalid time window: start time is greater than end time.</span>
        </div>
      )}
      <form className="form-small">
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label className="control-label" htmlFor="containerDeliveryStartTime">
                Start time
              </label>
              <TimeSelect
                className="form-control"
                name="inboundStartTime"
                format24hour={false}
                value={inboundStartTimeFormatted}
                onChange={startTimeChangeHandler}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label className="control-label" htmlFor="containerDeliveryEndTime">
                End time
              </label>
              <TimeSelect
                className="form-control"
                name="containerDeliveryEndTime"
                format24hour={false}
                value={inboundEndTimeFormatted}
                onChange={endTimeChangeHandler}
              />
            </div>
          </div>
        </div>
        <div className="form-group">
          <button
            name="button"
            type="button"
            className="btn cta btn-confirm"
            disabled={showValidation}
            onClick={confirmDelivery}
          >
            <i className="fa fa-check"></i> Confirm Inbound
          </button>
        </div>
      </form>
      <hr />
    </div>
  );
};

export default ConfirmInbound;
